import { FederationEvent } from '../types/types';

/**
 * Publishes whether Intercom is available (company licensed / JWT from /license/intercom)
 * for federated remotes (e.g. aidi) to gate the openIntercomChat tool.
 */
export function publishIntercomAvailability(available: boolean): void {
  if (typeof window === 'undefined') return;
  window.__FEDERATION_BRIDGE__?.communicationService?.publish(
    FederationEvent.INTERCOM_AVAILABILITY_UPDATED,
    available
  );
}
